// src/components/layout/ScrollToTop.jsx
// STATUS: active | UPDATED: 2026-08-30
// LOG:
//   2026-08-30  New. Every route change starts at the top of the page.
//
// Without this a router keeps the window's scroll position across navigations.
// Scroll halfway down the roadmap, tap through to a step, and the new page opens
// already scrolled past its own heading, which reads as the top being cut off.
//
// A hash link is left alone, because somebody asking for #section means it.
//
// Instant rather than smooth on purpose: a route change is not a scroll, and
// animating it makes a fast navigation feel like a slow one. It also respects
// anybody who has asked their system to reduce motion, for whom a surprise
// animated jump is worse than a jump.

import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function ScrollToTop() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (hash) return
    // Two frames, because a page that renders its content in an effect can grow
    // after the first paint and pull the viewport back down with it.
    const id = requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
      requestAnimationFrame(() => window.scrollTo({ top: 0, left: 0, behavior: 'instant' }))
    })
    return () => cancelAnimationFrame(id)
  }, [pathname, hash])

  return null
}
